export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const hasGaMeasurementId = Boolean(GA_MEASUREMENT_ID);

export const trackGaPageView = ({ page_path, page_title, page_location }) => {
  if (!hasGaMeasurementId || typeof window === "undefined" || typeof window.gtag !== "function") {
    return false;
  }

  window.gtag("event", "page_view", {
    page_path,
    page_title,
    page_location,
    send_to: GA_MEASUREMENT_ID,
  });

  return true;
};

export const trackGaEvent = (eventName, params = {}) => {
  if (!hasGaMeasurementId || typeof window === "undefined" || typeof window.gtag !== "function") {
    return false;
  }

  window.gtag("event", eventName, {
    ...params,
    send_to: GA_MEASUREMENT_ID,
  });

  return true;
};

export const getGaPagePath = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return `${window.location.pathname}${window.location.search || ""}`;
};